/** Идентификаторы встроенных профилей — отдельно, чтобы на них могли ссылаться правила. */
export const GOST_7_32 = 'gost-7.32-2017';
export const GOST_2_105 = 'gost-r-2.105-2019';
